'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExtendableError = require('./ExtendableError');

var _ExtendableError2 = _interopRequireDefault(_ExtendableError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Typed error for when no memory with a given id exists
 * @param {string} courseId
 */
class MemoryDoesNotExistError extends _ExtendableError2.default {
  constructor(id) {
    super(`memory: ${id} does not exist`);

    this.id = id;
  }
}
exports.default = MemoryDoesNotExistError;